// Droit d'opposition to the SNDS linkage (self-service): confirms, then flags
// the participant's own NIR row as opposed — it is excluded from every future
// appariement export from that moment. Idempotent server-side; leaving the
// study triggers the same flag automatically.
import { IonModal } from "@ionic/react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useConfig } from "../../contexts/ConfigContext";
import useToast from "../../hooks/useToast";
import { postNirOpposition } from "../../services/user.service";
import {
  ModalOverlay,
  ModalCard,
  ModalTitle,
  ModalDescription,
  ModalActions,
  ModalPrimaryButton,
  ModalQuietButton,
} from "../../components/atoms/ModalKit";

interface Props {
  isOpen: boolean;
  onDismiss(): void;
  // Parent refreshes its status display (button → "recorded" state).
  onOpposed(): void;
}

const NirOppositionModal: FC<Props> = ({ isOpen, onDismiss, onOpposed }) => {
  const { t } = useTranslation();
  const { study } = useConfig();
  const present = useToast();

  const handleConfirm = async () => {
    try {
      await postNirOpposition(study.id);
      present(t("profile_nir_opposition_success"));
      onOpposed();
      onDismiss();
    } catch (e) {
      present(e?.response?.data?.message || t("common_server_error_desc"));
    }
  };

  return (
    <IonModal
      className="resonance-modal"
      isOpen={isOpen}
      backdropDismiss={true}
      onWillDismiss={onDismiss}
    >
      <ModalOverlay onClick={onDismiss}>
        <ModalCard onClick={(e) => e.stopPropagation()}>
          <ModalTitle>{t("profile_nir_opposition_title")}</ModalTitle>
          <ModalDescription>
            {t("profile_nir_opposition_message")}
          </ModalDescription>

          <ModalActions>
            <ModalQuietButton type="button" onClick={onDismiss}>
              {t("common_cancel")}
            </ModalQuietButton>
            <ModalPrimaryButton type="button" onClick={handleConfirm}>
              {t("profile_nir_opposition_confirm")}
            </ModalPrimaryButton>
          </ModalActions>
        </ModalCard>
      </ModalOverlay>
    </IonModal>
  );
};

export default NirOppositionModal;
